export default __webpack_public_path__ + "static/media/telegramlogo.16afb29f.gif";